<template>
  <v-layout row>
    <v-flex xs12>
      <v-card class="pa-2 pb-4" flat>
        <v-card-title primary class="title">
          Типы элементов оргструктуры
          <v-btn outline color="secondary" @click.native="openTypeForm" v-if="accesses.type_create" small>+ Добавить</v-btn>
        </v-card-title>
        
        <v-layout row wrap>
          <v-flex xs12 sm4 md3 lg2 class="mb-3">
            <dantser-tree
              ref="typesTree"
              :selectMode="2"
              :source="typesTree"
              @click-node="nodeClicked($event)"
              @ctx-menu="openCtxMenu($event)"
            ></dantser-tree>
          </v-flex>
          <v-flex xs12 sm8 md9 lg10 v-show="typeDescription.length>0">
            <p class="title">Описание типа:</p>
            <p class="subheading">{{typeDescription}}</p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <type-form v-if="dialog" :data="formType" :editMode="editMode" @close-dialog="dialog=false"></type-form>
    </v-dialog>

    <context-menu id="types-context-menu" ref="ctxMenu">
      <li @click="editType" v-if="accesses.type_update"><v-icon small>mdi-pencil</v-icon> Редактировать</li>
      <li @click="deleteType" v-if="accesses.type_delete"><v-icon small>mdi-delete</v-icon> Удалить</li>
    </context-menu>

  </v-layout>

</template>

<script>
  import TypeForm from './TypeForm'
  import contextMenu from 'vue-context-menu'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Types',

    components:{
      'type-form':TypeForm,
      'context-menu' : contextMenu,
    },
  
    computed:{
      accesses(){
        return this.$store.state.app.account.accesses['orgstructure'] || {}
      },
      ...mapGetters('orgstructure', ['typesTree']),
    },
    
    created(){
      if(!this.accesses.type_access){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      }
      this.getTypesTree()
    },
    
    data(){
      return {
        dialog: false,
        formType: {},
        editMode: false,
        typeDescription: '',
        currentSelectedType: null,
      }
    },
    
    methods:{
      getTypesTree(){
        this.$store.dispatch('orgstructure/getTypesTree')
      },

      openTypeForm(){
        this.editMode = false
        this.formType = {
          "id": "",
          "name": "",
          "description": "",
          "iconcolor": "#000000"
        }
        this.dialog = true
      },

      nodeClicked(node){
        this.typeDescription = node.description || ""
      },
  
      openCtxMenu(eventData) {
        if(this.accesses.type_update || this.accesses.type_delete ){
          this.$refs.ctxMenu.open()
          this.currentSelectedType = eventData.data
        }
      },

      editType(){
        this.editMode = true
        this.formType = this.currentSelectedType
        this.dialog = true
        this.currentSelectedType = null
      },

      deleteType(){
        this.$store.dispatch('orgstructure/deleteType', this.currentSelectedType.id).then( response => {
          this.currentSelectedType = null
        })
      },
     
    }

  }
</script>

<style>
  #types-context-menu ul.ctx-menu li{
    padding: 5px 7px 5px 10px;
    cursor: pointer;
    font-size: 1rem;
  }
  #types-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #types-context-menu ul.ctx-menu li i{
    width: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Types/Types.vue